import { FC, ReactNode } from 'react';
import Box from '@mui/material/Box';
import { Helmet } from 'react-helmet';
import Header from 'app/components/Header';
import Footer from 'app/components/Footer';
import useScrollTop from 'app/hooks/useScrollTop';
import { isMobile } from 'utils/isMobile';

/**
 * Rendered height of the desktop header in px; static pages use it for
 * sticky/anchor-scroll offsets.
 */
export const HEADER_OFFSET = 92;

interface Props {
  title: string;
  metaDescription: string;
  children: ReactNode;
}

const StaticPageLayout: FC<Props> = ({ title, metaDescription, children }) => {
  useScrollTop(true);

  return (
    <Box
      display="flex"
      flexDirection="column"
      minHeight="100vh"
      bgcolor="common.white"
    >
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={metaDescription} />
      </Helmet>

      {isMobile ? <Header backButton /> : <Header flushBottom />}

      {/* Font family and smoothing come from the theme via CssBaseline */}
      <Box
        component="main"
        flexGrow={1}
        sx={{ color: 'staticPages.text.body' }}
      >
        {children}
      </Box>

      {!isMobile && <Footer />}
    </Box>
  );
};

export default StaticPageLayout;
